module.exports = __webpack_public_path__ + "img/expertise2.a3e1fdfd.png";